import React from "react";
import { makeStyles } from "@material-ui/styles";
import ChipElement from "./ChipElement";

interface Props {
  chipData: { key: string; label: string }[];
  handleDelete?: (v?) => void;
  dark?: boolean;
  icon?: string;
  selectedChips?: [];
}

const useStyle = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    listStyle: "none",
    padding: 1,
    margin: 0,
    boxShadow: "none",
    marginTop: 8,
  },
}));

const ChipList = ({
  chipData,
  handleDelete = undefined,
  dark = true,
  icon = "",
  selectedChips = [],
}: Props) => {
  const classes = useStyle();
  const sortedList = chipData.sort((a: any, b: any) =>
    a.label.localeCompare(b.label),
  );
  return (
    <ul className={classes.root}>
      {sortedList.map((data: any) => {
        return (
          <li key={data.key}>
            <ChipElement
              handleDelete={handleDelete}
              data={data}
              dark={dark}
              icon={icon}
              selectedChips={selectedChips}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default ChipList;
